import $ from 'jquery';
import 'slick-carousel';

const initCarousel = () => {
  const gallerySliders = document.querySelectorAll('[js-gallery-slider]');

  if (gallerySliders) {
    Array.prototype.forEach.call(gallerySliders, slider => {
      const mainSlider = slider.querySelectorAll('[js-gallery-slider-main]')[0];
      const subSlider = slider.querySelectorAll('[js-gallery-slider-sub]')[0];
      const captionSlider = slider.querySelectorAll(
        '[js-gallery-slider-caption]'
      )[0];

      $(mainSlider).slick({
        slidesToShow: 1,
        asNavFor: [slider.querySelectorAll('[js-gallery-slider-caption]')[0]],
        speed: 300,
        prevArrow: slider.querySelectorAll('[js-gallery-slider-prev]')[0],
        nextArrow: slider.querySelectorAll('[js-gallery-slider-next]')[0],
        responsive: [
          {
            breakpoint: 800,
            settings: {
              infinite: false
            }
          }
        ]
      });

      $(subSlider).slick({
        arrows: false,
        initialSlide: 1,
        slidesToShow: 1,
        speed: 300
      });

      $(captionSlider).slick({
        arrows: false,
        slidesToShow: 1,
        speed: 300,
        fade: true
      });

      $(mainSlider).on(
        'beforeChange',
        (event, slick, currentSlide, nextSlide) => {
          const decl = currentSlide - nextSlide;
          const i = (currentSlide || 0) + 1;

          if (decl === 1 || decl === (slick.slideCount - 1) * -1) {
            $(subSlider).slick('slickGoTo', i - 1);
          } else {
            $(subSlider).slick('slickGoTo', i + 1);
          }
        }
      );
    });
  }
};

const gallerySlider = async () => {
  initCarousel();
};

export default gallerySlider;
